import { Checkbox } from "@material-tailwind/react";

export function CheckboxDefault() {
  return <Checkbox defaultChecked />;
}
